import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';
import { makeStyles } from '@material-ui/core/styles';

export type ISummaryLinksStylesClasses =
  | 'editIcon'
  | 'container'
  | 'item'
  | 'itemCentered'
  | 'pinIcon'
  | 'flexDisplay'
  | 'flexDirection'
  | 'noUnderline'
  | 'newLink'
  | 'icon'
  | 'valueMyCarIcon'
  | 'halfWidth'
  | 'fullLinksDisplay'
  | 'summaryIconGrid'
  | 'summaryText';

const summaryLinksStyles = makeStyles<ISpcTheme, ISummaryLinksStylesClasses>(
  theme => ({
    container: {
      marginTop: '16px',
      [theme.breakpoints.down('xs')]: {
        marginTop: '5px',
      },
    },
    fullLinksDisplay: {
      paddingLeft: '5%',
      [theme.breakpoints.down(1025)]: {
        paddingLeft: '25%',
      },
      [theme.breakpoints.down('xs')]: {
        paddingLeft: '5%',
      },
    },
    item: {
      display: 'flex',
      flexBasis: '50%',
      flexGrow: 1,
    },

    itemCentered: {
      justifyContent: 'center',
    },
    editIcon: {
      width: '18px',
      height: '18px',
      position: 'relative',
      marginRight: '2px',
    },
    pinIcon: {
      fontSize: theme.typography.fontLG,
      marginBottom: '-4px',
    },
    icon: {
      marginRight: '4px',
    },
    newLink: {
      color: theme.palette.secondary.main,
      textDecoration: 'underline',
    },
    noUnderline: {
      textDecoration: 'none',
    },
    flexDisplay: {
      display: 'flex',
    },
    flexDirection: {},
    valueMyCarIcon: {
      position: 'relative',
      left: '-2px',
      height: 'auto',
      width: 'auto',
      padding: '1px',
      borderRadius: '50%',
      border: `1.5px solid ${theme.palette.secondary.main}`,
    },
    halfWidth: {
      width: '50%',
    },
    summaryText: {},
    summaryIconGrid: {},
  }),
  { name: 'Customise_SummaryLinks' },
);

export default summaryLinksStyles;
